export enum Role {
  ADMIN = 1,
  EDITOR = 2,
  READER = 3
}